import React, { useState } from "react";
import { Question } from "../types";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import YesOrNoForm from "./YesNoForm";
import QuestionPreviewContainer from "./QuestionPreviewContainer";
import useDeleteSurveyQuestion from "../CustomHooks/useDeleteSureveyQuestion";

interface YesNoOptionsPreviewDisplayProps {
    question: Question;
    questionText: string;
    options: string[];
}

export default (props: YesNoOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    const [ selection, setSelection ] = useState<string>('yes');
    
    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);

    const handleEditQuestion = () => {
        setModalOpen(true);
        // try{
        //     updateSurveyQuestion(user, survey, question);
        //     dispatch(updateQuestion(question));
        // }catch(err){
        //     console.error(err);
        // }        
    }

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
        <div className="flex gap-4">
            <button onClick={() => setSelection('yes')} className={`w-1/2 bg-[#${selection === 'yes' ? '3da8e2' : '1b1a1a'}] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest`}>{options[0]}</button>
            <button onClick={() => setSelection('no')} className={`w-1/2 bg-[#${selection === 'no' ? '3da8e2' : '1b1a1a'}] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest`}>{options[1]}</button>
        </div>
        <YesOrNoForm openState={modalOpen} onClose={() => setModalOpen(false)} question={question}/>
        </QuestionPreviewContainer>
    )
}